import React from "react"

import * as styles from "./index.module.scss"

export type Props = {
  url: string
}

const BlogEmbedVideo = ({ url }: Props) => (
  <figure className={styles.figure}>
    <iframe
      width="100%"
      height="100%"
      src={url}
      title="Video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
    />
  </figure>
)

export default BlogEmbedVideo
